const APP_VERSION = 'v5.6.2.1';

export default APP_VERSION;
